const jquery = window.jQuery || window.$;

export default jquery;
export { jquery as $ };
